import ContactPage from '../elements/ContactPage';

function RequestQuote() {
  return <ContactPage initialTab="quote" />;
}

export default RequestQuote;
